import { Component, OnDestroy, OnInit } from '@angular/core';

import { RoutingService, TranslatePipe } from '@spartacus/core';
import { UserAccountService } from '@spartacus/user/account/core';
import { Observable, Subscription, combineLatest } from 'rxjs';
import { CartQuoteSummary } from 'src/app/models/cart-quote-summary.model';
import { KnBrCartQuoteSummaryService } from 'src/app/services/kn-br-cart-quote.service';
import { KnBrCustomerContextService } from 'src/app/store/kn-br-customer-context/kn-br-customer-context.service';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'kn-br-cart-quote-summary',
    templateUrl: './kn-br-cart-quote-summary.component.html',
    styleUrls: ['./kn-br-cart-quote-summary.component.scss'],
    imports: [AsyncPipe, TranslatePipe]
})
export class KnBrCartQuoteSummaryComponent implements OnInit, OnDestroy {
  openCartsCount$: Observable<CartQuoteSummary[]> = this.cartQuoteSummaryService.loadCartsCounter();
  cartsValue$: Observable<CartQuoteSummary[]> = this.cartQuoteSummaryService.loadCartsValue();
  quotesCount$: Observable<CartQuoteSummary[]> = this.cartQuoteSummaryService.loadQuotesCounter();
  quotesValue$: Observable<CartQuoteSummary[]> = this.cartQuoteSummaryService.loadQuotesValue();
  subscription: Subscription;

  constructor(
    private cartQuoteSummaryService: KnBrCartQuoteSummaryService,
    private routingService: RoutingService,
    private knBrCustomerContextService: KnBrCustomerContextService,
    protected userService: UserAccountService
  ) {}

  ngOnInit() {
    combineLatest([this.userService.get(), this.knBrCustomerContextService.getActiveCustomerNumber()]).subscribe(
      ([user, customerNumber]) => {
        if ((user && user.roles && !user.roles?.includes('bravaNSMgroup')) || (user && user.roles === undefined)) {
          this.cartQuoteSummaryService.getCartsCounter(customerNumber);
          this.cartQuoteSummaryService.getCartsValue(customerNumber);
          this.cartQuoteSummaryService.getQuotesCounter(customerNumber);
          this.cartQuoteSummaryService.getQuotesValue(customerNumber);
        }
      }
    );
  }

  navigate(url: string) {
    this.routingService.goByUrl(url);
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.cartQuoteSummaryService.cartsCounterResult$.next(null);
    this.cartQuoteSummaryService.cartsValueResult$.next(null);
    this.cartQuoteSummaryService.quotesCounterResult$.next(null);
    this.cartQuoteSummaryService.quotesValueResult$.next(null);
  }
}
